export default __webpack_public_path__ + "static/pay-1-471bb644abbac30d1b50a7a2f9aa0a1d.png";